<template>
	<div class="QuestionManage">
		<a-form-model layout="inline" style="margin-top:15px;">
			<a-form-model-item label="题目">
				<a-input placeholder="请输入" allow-clear :maxLength="30" v-model="search.topic" @keyup.enter="getList(1)"/>
			</a-form-model-item>
			<a-form-model-item label="关联游戏">
				<a-select
					@mouseenter="selectMethods"
					ref="selectNode"
					:filter-option="filterOption"
					allowClear
					v-model="search.contentId"
					placeholder="请选择关联游戏"
					style="width:198px;">
					<a-select-option
						:key="item.id"
						:value="item.id"
						v-for="item in gameList">
						{{ item.name }} {{ item.versionName ? ' - ' + item.versionName : ''}}
					</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item>
				<a-button type="primary" @click="getList(1)">查询</a-button>
			</a-form-model-item>
			<a-form-model-item >
				<a-button v-permission="'/content/GamesComment/EditQuestion'" type="primary" @click="add()">添加</a-button>
			</a-form-model-item>
		</a-form-model>
		<div class="table">
			<a-table
				:columns="columns"
				:scroll="{y: 350}"
				rowKey="id"
				@change="handleTableChange"
				:pagination="table.tablePagination"
				:loading="table.tableLoading"
				:dataSource="table.tableDataSource">
				<div slot="contentNames" slot-scope="text">
					<span v-if="text.contentInfos.length">
						<span v-for="(item,index) in text.contentInfos" :key="item.id">{{ index == 0 ? item.name : '、' + item.name }}</span>
					</span>
					<span v-else>全部</span>
				</div>
				<div slot="launchRate" slot-scope="text">
					{{ text.launchRate }}%
				</div>
				<div slot="enabled" slot-scope="text">
					<a-switch checked-children="启用" un-checked-children="禁用" @click="enabledChange(text)" :checked="text.enabled"/>
				</div>
				<div slot="action" slot-scope="text" >
					<a v-permission="'/content/GamesComment/EditQuestion'" @click="edit(text)">编辑</a>
					<a-popconfirm title="确定删除？" @confirm="isDelete(text)">
						<a style="color:#f00;margin-left: 15px;">删除</a>
					</a-popconfirm>

				</div>
			</a-table>
		</div>
	</div>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
const columns = [
	{title: '题目',dataIndex: 'topic'},
	{title: '关联游戏',scopedSlots: { customRender: 'contentNames' }},
	{title: '投放率',scopedSlots: { customRender: 'launchRate' }},
	{title: '状态',scopedSlots: { customRender: 'enabled' }},
	{title: '操作',scopedSlots: { customRender: 'action' }},
]
export default {
	name:'QuestionManage',
	data (){
		return {
			search:{
				topic:undefined,
				contentId:undefined
			},
			gameList:[],
			columns,
			table: tableRelevant.call(this,this.getList),
		}
	},
	mounted(){
		this.getList(1)
		this.getAllContentByType()
	},
	methods:{
		clearSearch(){
			this.search = {
				topic:undefined,
				contentId:undefined
			}
			this.getList(1)
		},
		selectMethods(){
			if(this.$refs.selectNode.popupRef){
				console.log(this.$refs.selectNode.popupRef);
				let item = this.$refs.selectNode.popupRef
				item.align.overflow.adjustY = false
			}
		},
		filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
		add(){
			this.$router.push({
				path:'/content/GamesComment/EditQuestion',
				query:{

				}
			})
		},
		edit(text){
			this.$router.push({
				path:'/content/GamesComment/EditQuestion',
				query:{
					id:text.id
				}
			})
			// localStorage.setItem('QuestionManage',JSON.stringify(text))
		},
		isDelete(text){
			let formData = new FormData();
			formData.append('ids',[text.id])
			this.$http.GamesComment.deleteTopic(formData)
			.then(res =>{
				const { status, data, message} = res;
					this.$message.success('操作成功');
					this.getList(1)
				
			})
		},
		handleTableChange(pagination, filters, sorter){

		},

		// 获取列表数据
		getList(pageIndex){
			let params = {
				pageIndex:pageIndex || this.table.tablePagination.current,
				pageSize:this.table.tablePagination.pageSize,
				...this.search
			}
			this.table.tableLoading = true
			this.$http.GamesComment.getTopicPageList(params)
			.then(res =>{
				const { status, data, message} = res;
					// data.items.forEach(v =>{
					// 	v.names = []
					// 	for(let key in v.contentNames){
					// 		v.names.push(key)
					// 	}
					// })
					this.table.tableDataSource = data.items;
					this.table.tablePagination.total = data.totalCount;
                    this.table.tablePagination.current = data.pageIndex;
					console.log(this.table.tableDataSource);
				
			}).finally(() => {
        this.table.tableLoading = false
      })
		},
		// 获取关联游戏
		getAllContentByType(){
			let params = {
				contentTypeList:[1,2]
			}
			this.$http.GamesComment.getAllContentByType(params)
			.then(res =>{
				const { status, data, message } = res;
					this.gameList = data;
			
			})
		},
		// 修改列表状态
		enabledChange(text){
			let formData = new FormData();
			formData.append('id',text.id)
			this.$http.GamesComment.updataStatusTopic(formData)
			.then(res =>{
					text.enabled = !text.enabled
			})
		}
	}
}
</script>

<style scoped>
.table{
	margin-top: 15px;
}
</style>
